const getParamsString = (params) => {
    return JSON.stringify(params)
        .replace(/["{}]/g, '')
        .replace(',', '&')
        .replace(':', '=');
};

class Cache {
    memcached = null;
    data = {};

    /**
     *
     * @param {string} host
     * @param {String} url
     * @param {Object|undefined} params
     */
    constructor(host, url, params) {
        if (!process.browser && process.env.MEMCACHED_DATA_ADDRESS) {
            const paramsString = params ? '?' + getParamsString(params) : '';
            this.key = host + url + paramsString;
            const Memcached = require('memcached');

            this.memcached = new Memcached(process.env.MEMCACHED_DATA_ADDRESS + ':11211', {
                timeout: 1000,
                maxTimeout: 1000,
                reconnect: 1000,
                failures: 1,
                remove: true,
                idle: 1000,
                retry: 1000,
                failuresTimeout: 1000,
                retries: 1,
            });
        }
    }

    flush = async() => {
        if (this.memcached) {
            return new Promise((resolve, reject) => this.memcached.flush((err, data) => {
                this.memcached.end();

                if (err) {
                    reject(err);
                }

                resolve(data);
            }));
        } else {
            return Promise.reject(false);
        }
    };

    get = async() => {
        if (this.memcached) {
            const getCache = (key) => new Promise(resolve => this.memcached.get(key, (err, data) => {
                resolve(data);
            }));

            const result = await getCache(this.key);
            this.memcached.end();
            return result;
        }
    };

    set = (value) => {
        if (this.memcached) {
            this.memcached.set(this.key, value, 60 * 15, () => {});
            this.memcached.end();
        }
    };
}

export default Cache;
